import DefaultClient from "./page-client";

export * from "./cursor-client";
export * from "./infinite-client";
export * from "./log-client";
export * from "./page-client";
export * from "./query-client";
export * from "./refresh-client";
export * from "./request-client";
export * from "./resource-client";

export * from "./use-dev-mode";
export * from "./use-merge-query";
export * from "./use-revertable-query";
export * from "./use-storage-state";

export { configureClient } from "./client-instance";
export { normalizeQuery } from "./utils";
export type { IQuery } from "./utils";

export default DefaultClient;
